import React from "react";
import { motion } from "framer-motion";
import { Camera } from "lucide-react";
import { VISAGE_SERVICES } from "@/data/content";
import { Reveal } from "./Reveal";
import { ASavoir } from "./ASavoir";
import { DotText } from "./DotText";

const EASE = [0.22, 1, 0.36, 1];

export const VisageServices = () => {
  return (
    <div className="mt-20 md:mt-28">
      <Reveal className="max-w-2xl mb-10 md:mb-14">
        <h2 className="font-serif-display font-light text-[#4b2018] text-3xl md:text-4xl">
          Les soins du visage
        </h2>
      </Reveal>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-x-10 md:gap-y-12 max-w-5xl">
        {VISAGE_SERVICES.map((item, i) => (
          <motion.div
            key={item.name}
            data-testid={`visage-service-${i}`}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 1.1, delay: (i % 3) * 0.1, ease: EASE }}
          >
            <div className="overflow-hidden rounded-md aspect-[4/3]">
              {item.image ? (
                <img
                  src={item.image}
                  alt={`${item.name} — Ninaa Beauty`}
                  loading="lazy"
                  style={{ objectPosition: item.imgPos || "center" }}
                  className="h-full w-full object-cover"
                />
              ) : (
                <div className="h-full w-full bg-[#f6f1e9] border border-[#ece4d7] grid place-items-center text-[#b07a63]">
                  <div className="flex flex-col items-center">
                    <Camera size={24} strokeWidth={1.2} />
                    <span className="mt-2 text-[11px] tracking-[0.22em] uppercase">
                      Photo à venir
                    </span>
                  </div>
                </div>
              )}
            </div>

            <div className="mt-4">
              <div className="flex items-baseline flex-wrap gap-x-3 gap-y-1">
                <h3 className="font-serif-display text-xl text-[#4b2018]">
                  {item.name}
                </h3>
                {item.soon && (
                  <span className="text-[10px] tracking-[0.22em] uppercase text-[#b07a63] border border-[#e3d8c6] rounded-full px-2.5 py-0.5">
                    À venir
                  </span>
                )}
              </div>
              <p className="mt-2 text-sm leading-relaxed text-[#4b2018]">
                {item.sentence}
              </p>
              {item.meta && (
                <p className="mt-3 text-sm text-[#944639]"><DotText text={item.meta} /></p>
              )}
            </div>
          </motion.div>
        ))}
      </div>

      <Reveal className="mt-10">
        <ASavoir />
      </Reveal>
    </div>
  );
};
